import { render, staticRenderFns } from "./BbppNoticiasBancaPersonas.vue?vue&type=template&id=043684dd"
import script from "./BbppNoticiasBancaPersonas.vue?vue&type=script&lang=js"
export * from "./BbppNoticiasBancaPersonas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports